import { render, staticRenderFns } from "./customer_orders.vue?vue&type=template&id=6badd0f4&scoped=true&"
import script from "./customer_orders.vue?vue&type=script&lang=js&"
export * from "./customer_orders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6badd0f4",
  null
  
)

export default component.exports